module.exports = __webpack_public_path__ + "static/media/TallinnBiennial.a211b533.svg";